import { MainLayout } from '../../components/layouts/MainLayout.tsx';
import { useAppSelector } from '../../stores/store.ts';
import { INotification } from '../../interfaces/account/notification/INotification.ts';
import { AccountNotificationItem } from '../../components/account/notification/widgets/AccountNotificationItem.tsx';
import { useModal } from '../../hooks/useModal.tsx';
import { ReactNode } from 'react';
import { NotificationType } from '../../types/account/notificationTypeTypes.ts';
import AccountNotificationDetailsModalContent
    from '../../components/account/notification/modals/AccountNotificationDetailsModalContent.tsx';
import apiNet from '../../newApi/apiNet.ts';

export const AccountNotificationsPage = () => {
    const notifications = useAppSelector(state => state.notifications.items);
    const { showModal } = useModal();

    const modalHeader = (): ReactNode => {
        return <></>;
    };

    const handleOnClick = async (notification: INotification) => {
        await apiNet.postNotificationMarkAsRead(notification.id);
        switch (notification.type) {
            case NotificationType.INVOICE_ISSUED:
                break;
            case NotificationType.PROGRAM_STARTING_SOON:

                break;
            case NotificationType.MAINTENANCE_ALERT:
                showModal(
                    modalHeader(),
                    <AccountNotificationDetailsModalContent notification={notification} />,
                );
                break;
            case NotificationType.SYSTEM_ANNOUNCEMENT:
                break;
        }
        // <FavoriteButton name={favorite.name} type={favorite.type} />);
    };
    return (
        <MainLayout contentPadding={'px-0 pb-4 pt-14 md:pt-0'}>
            <div className={'bg-neutral-900 pt-4'}>
                <p className={'ml-4 text-neutral-400 text-md'}>Twoje konto</p>
                <h1 className={'text-3xl ml-4'}>Powiadomienia</h1>
                <div className={'w-full bg-neutral-800 h-0.5 my-5 mb-0'}></div>
            </div>
            <ul className={'w-full divide-y divide-white/5'}>
                {notifications.map((notification: INotification) => <AccountNotificationItem key={notification.id}
                                                                                             onClick={handleOnClick}
                                                                                             item={notification} />)}
            </ul>
        </MainLayout>
    );
};